import styles from "./Errors.module.css";
import { Btn } from "@/components/Generics/Btn";
import { SmallText } from "@/components/Generics/SmallText";
import { Title } from "@/components/Generics/Title";
import { Logo } from "@/components/Generics/Logo";
import { useNavigate } from "react-router-dom";

export const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <div className={styles.error}>
        <Logo type="white" />
        <Title>404 - Page Not Found</Title>
        <Btn action={() => navigate("/")} children="Go Home" />
        <SmallText>The page you’re looking for doesn’t exist.</SmallText>
      </div>
    </div>
  );
};

export default NotFound;
